module.exports = __webpack_public_path__ + "assets/gunicorn.33d33f7a.svg";